import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import { AnalyticsShell } from '../../../modules/analytics/analytics-shell'
import {
  PipelineAnalyticsPage,
  type PipelineSearch,
} from '../../../modules/analytics/pipeline-analytics-page'

/**
 * `/analytics/pipeline` - deal-stage funnel + won/lost by rep/source +
 * time-in-stage. The group-by + date-range filter live in the URL search params
 * (Zod-validated) so the view is shareable and survives reload.
 */
const pipelineSearchSchema = z.object({
  groupBy: z.enum(['stage', 'rep', 'source']).default('rep'),
  from: z.string().optional(),
  to: z.string().optional(),
})

export const Route = createFileRoute('/_authed/analytics/pipeline')({
  validateSearch: pipelineSearchSchema,
  component: PipelineRoute,
})

function PipelineRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate()
  return (
    <AnalyticsShell padded>
      <PipelineAnalyticsPage
        search={search as PipelineSearch}
        onSearchChange={(next) =>
          navigate({ to: '/analytics/pipeline', search: (prev) => ({ ...prev, ...next }) })
        }
      />
    </AnalyticsShell>
  )
}
